import Client from "../client/ClientSubscription"
const resource = "/api"
const checkView = (data) => {
  return Client.put(`${resource}/can_watch`, data)
}
const getKey = (params) => {
  return Client.get(`/api/web/sign_key`, { params })
}
const getTicket = () => {
  return Client.get(`${resource}/ticket`)
}
const userRepository = {
  checkView,
  getKey,
  getTicket
}

export default userRepository
